import { render, staticRenderFns } from "./PieAmtEdpTypePosteByFamillesRisquesChart.vue?vue&type=template&id=46c4fd20&"
import script from "./PieAmtEdpTypePosteByFamillesRisquesChart.vue?vue&type=script&lang=ts&"
export * from "./PieAmtEdpTypePosteByFamillesRisquesChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports